import React, { useState } from "react"
import { LanguageWrapper, LanguageLinkWrapper, Link } from "./style"
import {withTheme} from 'styled-components'
import { useScrollPosition } from "shared/Hooks/useScrollPosition"

export const LanguageSelector = withTheme(({ active, light, lang = 1 ,theme}) => {
  const languages = [
    {
      name: "PL",
      id: 1,
    },
    {
      name: "EN",
      id: 2,
    },
  ]
  const [selectedLanguage, setSelectedLanguage] = useState(lang)
  const [blackOnScroll, setBlackOnScroll] = useState(false)
  const isBrowser = typeof window !== `undefined`
  useScrollPosition(({prevPos,currPos}) => {
      if(isBrowser) {
          if(currPos.y < -window.innerHeight+100  && window.location.pathname !== '/kontakt') {
              setBlackOnScroll(true)
          }else {
              setBlackOnScroll(false)
          }
      }
  }, [blackOnScroll], false, false, 1000)
  return (
    <LanguageWrapper>
      {languages.map(language => (
        <LanguageLinkWrapper color={((light || blackOnScroll)&&!active?theme.color.black:theme.color.white)} key={language.id} className={`${language.id==selectedLanguage?'active':''}`}>
          <Link onClick={()=>setSelectedLanguage(language.id)}>{language.name}</Link>
        </LanguageLinkWrapper>
      ))}
    </LanguageWrapper>
  )
}
)
